<!--
  WhereaboutsList.vue
    行動予定情報一覧 Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div v-resize="onResize" v-scroll="onScroll" class="hm-wal-wrap" v-touch="{
    down: () => onSwipe('down'),
    right: () => onSwipe('right'),
  }">

    <!-- グループ選択 ボタン -->
    <v-layout row wrap align-center justify-center class="hm-wal-group-area">
      <v-flex xs3>
        <div class="hm-display-monitor hm-wal-search">
          <div :class="{'hm-hide': mScreenView}">
          <v-text-field
            flat
            label="Search"
            clearable
            v-model="mSearchStr"
          >
          </v-text-field>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="hm-cursor">
        <group-list @selectedGroupChanged="onSelectedGroupChanged" />
      </v-flex>
      <v-flex xs1 :class="{'hm-hide': mScreenView}">
        <v-btn flat icon color="primary" @click="onClickReload">
          <v-icon :size="mIconSize">refresh</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs2></v-flex>
    </v-layout>

    <!-- メンバ行先情報一覧 -->
    <v-container fluid class="pa-0 hm-wal-container">
      <!-- Mobile Layout -->
      <div :class="{'hm-hide': !$vuetify.breakpoint.xsOnly}">
        <whereabouts-info
          @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
          @lastStaffMounted="lastStaffMounted"
          v-for="whereabouts in mWhereaboutsListMobile"
          :key="whereabouts.id"
          :pWhereaboutsInfo="whereabouts"
          :pViewMode="'mobile'"
          :pLastStaffId="mLastStaffId"
          :pGridHeight="-1"
        />
      </div>

      <!-- Monitor Layout -->
      <div :class="{'hm-hide': $vuetify.breakpoint.xsAndDown}">
        <!-- Screen mode ON / 1 column -->
        <div :class="{'hm-hide': !isScreenView1Column}">
          <v-carousel
            :cycle="this.mCarouselsCycle1"
            :interval="mInterval"
            light
            hide-controls
            hide-delimiters
            :height="mDispAreaHeight"
            v-if="this.mCarouselPages > 1"
          >
            <v-carousel-item
              v-for="(pageElm, i) in mScreenDispList1col"
              :key="i"
              transition="fade"
              reverse-transition="fade"
            >
              <whereabouts-info
                @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
                @lastStaffMounted="lastStaffMounted"
                v-for="(whereabouts, k) in pageElm" :key="k"
                :pWhereaboutsInfo="whereabouts"
                :pViewMode="'wide1col'"
                :pLastStaffId="mLastStaffId"
                :pGridHeight="-1"
              />
            </v-carousel-item>
          </v-carousel>
          <div v-else>
            <!-- 表示ページ数が0～1の後に、部署選択などで複数ページになった場合、ページングできなくなるため処理を分ける -->
            <whereabouts-info
              @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
              @lastStaffMounted="lastStaffMounted"
              v-for="(whereabouts, k) in mScreenDispList1col[0]" :key="k"
              :pWhereaboutsInfo="whereabouts"
              :pViewMode="'wide1col'"
              :pLastStaffId="mLastStaffId"
              :pGridHeight="-1"
            />
          </div>
        </div>

        <!-- Screen mode ON / 2 column -->
        <div :class="{'hm-hide': !isScreenView2Column}">
          <div v-if="this.mCarouselPages > 1">
            <v-carousel
              :cycle="this.mCarouselsCycle2"
              :interval="mInterval"
              light
              hide-controls
              hide-delimiters
              :height="mDispAreaHeight"
            >
              <v-carousel-item
                v-for="(pageElm, i) in mScreenDispList2col"
                :key="i"
                transition="fade"
                reverse-transition="fade"
              >
                <v-layout wrap>
                  <v-flex xs6 class="hm-wal-clm">
                    <whereabouts-info
                      @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
                      @lastStaffMounted="lastStaffMounted"
                      v-for="(whereabouts, j) in pageElm.left"
                      :key="j"
                      :pWhereaboutsInfo="whereabouts"
                      :pViewMode="'wide2col'"
                      :pLastStaffId="mLastStaffId"
                      :pGridHeight="-1"
                    />
                  </v-flex>
                  <v-flex xs6 class="hm-wal-clm">
                    <whereabouts-info
                      @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
                      @lastStaffMounted="lastStaffMounted"
                      v-for="(whereabouts, k) in pageElm.right"
                      :key="k"
                      :pWhereaboutsInfo="whereabouts"
                      :pViewMode="'wide2col'"
                      :pLastStaffId="mLastStaffId"
                      :pGridHeight="-1"
                    />
                  </v-flex>
                </v-layout>
              </v-carousel-item>
            </v-carousel>
          </div>
          <div v-else-if="this.mCarouselPages === 1 && this.mScreenDispList2col.length !== 0">
            <!-- 表示ページ数が1の後に、部署選択などで複数ページになった場合、ページングできなくなるため処理を分ける -->
            <v-layout wrap>
              <v-flex xs6 class="hm-wal-clm">
                <whereabouts-info
                  @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
                  @lastStaffMounted="lastStaffMounted"
                  v-for="(whereabouts, j) in mScreenDispList2col[0].left"
                  :key="j"
                  :pWhereaboutsInfo="whereabouts"
                  :pViewMode="'wide2col'"
                  :pLastStaffId="mLastStaffId"
                  :pGridHeight="-1"
                />
              </v-flex>
              <v-flex xs6 class="hm-wal-clm">
                <whereabouts-info
                  @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
                  @lastStaffMounted="lastStaffMounted"
                  v-for="(whereabouts, k) in mScreenDispList2col[0].right"
                  :key="k"
                  :pWhereaboutsInfo="whereabouts"
                  :pViewMode="'wide2col'"
                  :pLastStaffId="mLastStaffId"
                  :pGridHeight="-1"
                />
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <!-- 表示データが0人の場合 -->
          </div>
        </div>

        <!-- Screen mode ON / Grid -->
        <div :class="{'hm-hide': !isScreenViewGrid}">
          <div v-if="this.mCarouselPages > 1">
            <v-carousel
              :cycle="this.mCarouselsCycleGrid"
              :interval="mInterval"
              light
              hide-controls
              hide-delimiters
              :height="mDispAreaHeight"
            >
              <v-carousel-item
                v-for="(pageElm, i) in mScreenGridList"
                :key="i"
                transition="fade"
                reverse-transition="fade"
              >
                <v-layout wrap>
                  <v-flex
                    class="hm-wal-clm hm-wal-grid-card"
                    v-for="(colObj, l) in pageElm"
                    :key="l"
                  >
                    <whereabouts-info
                      @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
                      @lastStaffMounted="lastStaffMounted"
                      v-for="(whereabouts, j) in colObj"
                      :key="j"
                      :pWhereaboutsInfo="whereabouts"
                      :pViewMode="'grid'"
                      :pLastStaffId="mLastStaffId"
                      :pGridHeight="mGirdCardHeight"
                    />
                  </v-flex>
                </v-layout>
              </v-carousel-item>
            </v-carousel>
          </div>
          <div v-else>
            <!-- 表示ページ数が0～1の後に、部署選択などで複数ページになった場合、ページングできなくなるため処理を分ける -->
            <v-layout wrap>
              <v-flex
                class="hm-wal-clm hm-wal-grid-card"
                v-for="(colObj, l) in mScreenGridList[0]"
                :key="l"
              >
                <whereabouts-info
                  @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
                  @lastStaffMounted="lastStaffMounted"
                  v-for="(whereabouts, j) in colObj"
                  :key="j"
                  :pWhereaboutsInfo="whereabouts"
                  :pViewMode="'grid'"
                  :pLastStaffId="mLastStaffId"
                  :pGridHeight="mGirdCardHeight"
                />
              </v-flex>
            </v-layout>
          </div>
        </div>

        <!-- Monitor Layout (Screen mode OFF) -->
        <div :class="{'hm-hide': mScreenView}">
          <v-layout wrap>
            <v-flex xs6 class="hm-wal-clm">
              <whereabouts-info
                @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
                @lastStaffMounted="lastStaffMounted"
                v-for="whereabouts in filteredWhereaboutsCol1"
                :key="whereabouts.staff_id"
                :pWhereaboutsInfo="whereabouts"
                :pViewMode="'column'"
                :pLastStaffId="mLastStaffId"
                :pGridHeight="-1"
              />
            </v-flex>
            <v-flex xs6 class="hm-wal-clm">
              <whereabouts-info
                @whereaboutsInfoSelected="onWhereaboutsInfoSelected"
                @lastStaffMounted="lastStaffMounted"
                v-for="whereabouts in filteredWhereaboutsCol2"
                :key="whereabouts.staff_id"
                :pWhereaboutsInfo="whereabouts"
                :pViewMode="'column'"
                :pLastStaffId="mLastStaffId"
                :pGridHeight="-1"
              />
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-container>

    <!-- SelectWhereaboutsInfoDialog -->
    <div class="hm-display-monitor">
      <selected-whereabouts-dialog ref="selectedWhereaboutsInfoDialog" @updateWhereaboutsInfo="onUpdateWhereaboutsInfo" />
    </div>

    <!-- サーバ送信状態表示Snackbar
    <info-snackbar ref="infoSnackbar">
      <div slot="msg">{{ $t("infomsg.getlist") }}</div>
    </info-snackbar> -->
    <!-- データ送信失敗Alart -->
    <errorinfo-dialog ref="srvErrorInfoDialog">
      <div slot="msg">{{ $t("errmsg.rcvfailed") }}</div>
    </errorinfo-dialog>
    <error-confirm-dialog ref="errorConfirmDialog">
      <div slot="msg">{{mErrorMsg}}</div>
    </error-confirm-dialog>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
//import moment from 'moment'
import { ROUTE_NAME, ROUTE_PATH } from '@/router/routes'
import { mapState } from 'vuex'
import WhereaboutsInfo from '@/components/WhereaboutsInfo'
import GroupList from '@/components/GroupList'
import SelectedWhereaboutsInfoDialog from '@/components/dialogs/SelectedWhereaboutsInfoDialog'
import ErrorInfoDialog from '@/components/dialogs/ErrorInfoDialog'
import ErrorConfirmDialog from '@/components/dialogs/ErrorConfirmDialog'

const RELOAD_INTERVAL = 20000

export default {
  name: 'WhereaboutsList',
  data: () => ({
    mOffsetTop: 0,  // スクロール位置
    mWhereaboutsListMobile: [],
    mWhereaboutsListMonitor: [],
    mCurrentSectionId: '',
    mCurrentGroupId: '',
    mDisplayListColumn1: [],
    mDisplayListColumn2: [],
    mScreenDispList1col: [],
    mScreenDispList2col: [],
    mScreenGridList: [],
    mIconSize: window.innerWidth * 0.03,
    mSearchStr: '',
    mSearchClassIdList: [],
    mSearchStateIdList: [],
    mAutoReloadId: '',
    mCarouselsCycle1: this.mScreenView && (this.mScreenLayout === '0'),
    mCarouselsCycle2: this.mScreenView && (this.mScreenLayout === '1'),
    mCarouselsCycleGrid: this.mScreenView && (this.mScreenLayout === '2'),
    mCarouselPages: 0,
    mInterval: 10000,
    mErrorMsg: '',
    mSrvErrStatus: false,
    mLastStaffId: '',
    mDispAreaHeight: '',
    mGridColNum: 5,
    mGridRowNum: 6,
    mGirdCardHeight: '',
  }),
  components: {
    'group-list': GroupList,
    'whereabouts-info': WhereaboutsInfo,
    'selected-whereabouts-dialog': SelectedWhereaboutsInfoDialog,
    'errorinfo-dialog': ErrorInfoDialog,
    'error-confirm-dialog': ErrorConfirmDialog,
  },
  mounted: function () {
    this.$log.debug('# WhereaboutsList')
    //this.$log.debug('★[waList - mouted] mScreenView(' + this.mScreenView + ') mScreenLayout(' + this.mScreenLayout + ') mDispItem(' + this.mDispItem + ') mCarouselInterval(' + this.mCarouselInterval + ')')
    // ページ切替間隔初期化
    this.mInterval = Number(this.mCarouselInterval) * 1000

    // パフォーマンス改善：不要なインスタンス生成を避ける
    if (this.$store.getters.isMobile) {
      this.mWhereaboutsListMobile = this.mWhereaboutsList
      this.mIconSize = window.innerWidth * 0.08
    }
    else {
      this.mWhereaboutsListMonitor = this.mWhereaboutsList
      this.mIconSize = window.innerWidth * 0.03
    }
    this.$watch('$window.isFocus', function (current, previous) {
      // ブラウザ版の場合はFocus検知でリスト再取得
      current && !this.$store.getters.isMobile && this.onFocus()
    })
    this.$watch('$window.isResume', function (current, previous) {
      // アプリ版の場合はResume検知でリスト再取得
      current && this.$store.getters.isMobile && this.onFocus()
    })

    // 表示ページをgroupに変更
    this.$store.dispatch('aChangeCurrentPage', 'group')

    // 自動リロード起動
    if (this.mScreenView) {
      this.startAutoReload()
    }
  },
  destroyed: function () {
    this.$log.debug('# WhereaboutsList')
  },
  updated: function () {
    this.$log.debug('whereabouts list updated')
  },
  computed: {
    ...mapState({
      mWhereaboutsList: state => state.sWhereaboutsList,
      mWhSelectedOnMenu: state => state.sWhSelectedOnMenu,
      //mScreenView: state => state.systemSettings.sScreenView,
      //mScreenColumn: state => state.systemSettings.sScreenColumn,
      mScreenView: state => (state.systemSettings.sScreenLayout[0] !== '0'),
      mScreenLayout: state => state.systemSettings.sScreenLayout[1],
      mDispItem: state => state.systemSettings.sDispItem,
      mCarouselInterval: state => state.systemSettings.sCarouselInterval,
      mCurrentPage: state => state.currentPage.sCurrentPage,
    }),
    filteredWhereaboutsCol1: function () {
      if (this.mSearchStr === null || this.mSearchStr === '') {
        return this.mDisplayListColumn1
      }
      else {
        // 名前(表記/読み),Memo,行先検索(左列),役職,状態から検索
        return this.mDisplayListColumn1.filter((elm) => {
          let ret = (
            (elm.name.indexOf(this.mSearchStr) !== -1) ||
            (elm.name_phonetic.indexOf(this.mSearchStr) !== -1) ||
            (elm.comment.indexOf(this.mSearchStr) !== -1) ||
            (elm.dist_name.indexOf(this.mSearchStr) !== -1)
          )
          if (this.mSearchClassIdList.length !== 0) {
            ret = ret || (this.mSearchClassIdList.indexOf(elm.class) !== -1)
          }
          if (this.mSearchStateIdList.length !== 0) {
            ret = ret || (this.mSearchStateIdList.indexOf(elm.state) !== -1)
          }
          return ret
        })
      }
    },
    filteredWhereaboutsCol2: function () {
      if (this.mSearchStr === null || this.mSearchStr === '') {
        return this.mDisplayListColumn2
      }
      else {
        // 名前(表記/読み),Memo,行先検索(右列),役職,状態から検索
        return this.mDisplayListColumn2.filter((elm) => {
          let ret = (
            (elm.name.indexOf(this.mSearchStr) !== -1) ||
            (elm.name_phonetic.indexOf(this.mSearchStr) !== -1) ||
            (elm.comment.indexOf(this.mSearchStr) !== -1) ||
            (elm.dist_name.indexOf(this.mSearchStr) !== -1)
          )
          if (this.mSearchClassIdList.length !== 0) {
            ret = ret || (this.mSearchClassIdList.indexOf(elm.class) !== -1)
          }
          if (this.mSearchStateIdList.length !== 0) {
            ret = ret || (this.mSearchStateIdList.indexOf(elm.state) !== -1)
          }
          return ret
        })
      }
    },
    /*filteredWhereaboutsAll: function () {
      if (this.mSearchStr === '') {
        return this.mWhereaboutsListMonitor
      }
      else {
        return this.mWhereaboutsListMonitor.filter((elm) => {
          return (elm.name.indexOf(this.mSearchStr) !== -1)
        })
      }
    },*/
    isScreenView1Column: function () {
      return (this.mScreenView && (this.mScreenLayout === '0'))
    },
    isScreenView2Column: function () {
      return (this.mScreenView && (this.mScreenLayout === '1'))
    },
    isScreenViewGrid: function () {
      return (this.mScreenView && (this.mScreenLayout === '2'))
    },
  },
  watch: {
    mWhereaboutsList: function (current, previous) {
      //this.$log.debug('★[WaList] 行先一覧 変更検知 (' + moment().format('YYYY-MM-DD HH:mm:ss:SSS') + ')')
      if (this.$store.getters.isMobile) {
        this.mWhereaboutsListMobile = this.mWhereaboutsList
        if (this.mWhereaboutsList.length === 0) {
          this.mLastStaffId = ''
          this.lastStaffMounted()
        }
        else {
          this.mLastStaffId = this.mWhereaboutsList[this.mWhereaboutsList.length - 1].staff_id
        }
      }
      else {
        this.mWhereaboutsListMonitor = this.mWhereaboutsList
      }
      this.resetWhereaboutsList()
    },
    mWhSelectedOnMenu: function (current, previous) {
      if (current === true) {
        this.whSelectedOnMenu()
      }
    },
    mScreenView: function (current, previous) {
      //this.$log.debug('★[WaList] mScreenView 変更検知 (' + previous + ')→(' + current + ') (' + moment().format('YYYY-MM-DD HH:mm:ss:SSS') + ')')
      this.clearWhereaboutsList()   // データクリア

      if (current === true) {
        this.displayScreenView()
        this.startAutoReload()
      }
      else {
        this.mCarouselsCycle1 = false
        this.mCarouselsCycle2 = false
        this.mCarouselsCycleGrid = false
        this._make2ColumnList()
        this.stopAutoReload()
      }
    },
    /*mScreenColumn: function (current, previous) {
      //this.$log.debug('★[WaList] mScreenColumn 変更検知 (' + moment().format('YYYY-MM-DD HH:mm:ss:SSS') + ')')
      this.clearWhereaboutsList()   // データクリア
      this.displayScreenView()
    },*/
    mScreenLayout: function (current, previous) {
      //this.$log.debug('★[WaList] mScreenLayout 変更検知 (' + previous + ')→(' + current + ')')
      this.clearWhereaboutsList()   // データクリア
      this.displayScreenView()
    },
    mDispItem: function (current, previous) {
      //this.$log.debug('★[WaList] mDispItem 変更検知 (' + previous + ')→(' + current + ')')
      this.clearWhereaboutsList()   // データクリア
      this.displayScreenView()
    },
    mCarouselInterval: function (current, previous) {
      //this.$log.debug('★[WaList] mCarouselInterval 変更検知 (' + previous + ')→(' + current + ')')
      this.mInterval = Number(current) * 1000
      //this.clearWhereaboutsList()   // データクリア
      //this.displayScreenView()
    },
    mCurrentPage: function (current, previous) {
      if (current === 'group' && this.$store.getters.isMobile) {
        this.onRefresh()
      }
    },
    mSearchStr: function (current, previous) {
      //this.$log.debug('★mSearchStr変更検知(' + current + ')')
      this.mSearchClassIdList = []
      this.mSearchStateIdList = []
      if (current !== null && current !== '') {
        // 入力文字列を役職一覧から検索
        let classList = this.$store.getters.fClassByName(this.mSearchStr)
        if (classList.length !== 0) {
          for (let elem of classList) {
            this.mSearchClassIdList.push(elem.class_id.toString())
          }
        }

        // 入力文字列を状態一覧から検索
        let stateList = this.$store.getters.fStateByName(this.mSearchStr)
        if (stateList.length !== 0) {
          for (let elem of stateList) {
            this.mSearchStateIdList.push(elem.state_id.toString())
          }
        }
      }
    },
  },
  methods: {
    // -------------------------------------------------------------------------
    lastStaffMounted: function () {
      this.$emit('hideLoading')
    },
    // -------------------------------------------------------------------------
    onResize: function () {
      this.resetWhereaboutsList()
    },
    // -------------------------------------------------------------------------
    onFocus: function () {
      if (this.$store.getters.isWhereaboutsPage) {
        this.getWhereaboutsListAsyncWrap(this.mCurrentSectionId, this.mCurrentGroupId)
        this.getUserList()
        //this.getTeleworkingUserListAsync()
      }
    },
    // -------------------------------------------------------------------------
    // 行動予定情報リスト取得
    getWhereaboutsListAsyncWrap: async function (sectionId, groupId) {
      //this.$log.debug('★[WaList] 行先一覧取得(部署 ' + sectionId + '/' + groupId + ') (' + moment().format('YYYY-MM-DD HH:mm:ss:SSS') + ')')
      let retry = await this.getWhereaboutsListAsync(sectionId, groupId)
      if (retry) {
        // トークン再発行によるリトライ(戻り値は判定しない)
        this.getWhereaboutsListAsync(sectionId, groupId)
      }
    },
    getWhereaboutsListAsync: async function (sectionId, groupId) {
      let status = false
      const result = await this.$store.dispatch(
        'aGetWhereaboutsList',
        {
          companyId: this.$store.getters.loginUserCompanyId,
          sectionId: sectionId,
          groupId: groupId,
        })

      if (result.error || result.body.error) {
        if (result.status === 'Unauthorized') {
          // トークン認証エラーの場合
          this.$log.debug('token unauthorized')
          const reissue_result = await this.reissueLoginTokenAsync()
          if (!reissue_result.error && !reissue_result.body.error) {
            this.$log.debug('Token reissued. Retry to get WhereaboutsList')
            status = true
          }
          else {
            this.$refs.errorConfirmDialog.$emit('show', this.dispLoginPage)
          }
        }
        else if (result.status === 'VerError') {
          if (this.$store.getters.isMobile) {
            this.mErrorMsg = 'ご利用可能な最新バージョンがあります。アプリを更新してご利用ください。'
            this.$refs.errorConfirmDialog.$emit('show', this.dispLoginPage)
          }
          else {
            this.mErrorMsg = 'ご利用可能な最新バージョンがあります。更新しますか？'
            this.$refs.errorConfirmDialog.$emit('show', this.reloadPage)
          }
        }
        else if (result.status === 'IpError') {
          this.mErrorMsg = 'このIPアドレスからのアクセスは許可されていません'
          this.$refs.errorConfirmDialog.$emit('show', this.dispLoginPage)
        }
        else {
          this.mSrvErrStatus = true
          this.$refs.srvErrorInfoDialog.$emit('show')
          this.lastStaffMounted()
        }
      }
      else {
        if (this.mSrvErrStatus === true) {
          // サーバエラーダイアログ表示中
          this.mSrvErrStatus = false
          this.$refs.srvErrorInfoDialog.$emit('hide')
        }
      }

      return status
    },
    // -------------------------------------------------------------------------
    // テレワーク勤務中ユーザ一覧取得
    /*getTeleworkingUserListAsync: async function () {
      const result = await this.$store.dispatch(
        'aGetTeleworkingUserList',
        this.$store.getters.loginUserCompanyId
      )
      if (result.error) {
        this.mSrvErrStatus = true
        this.$refs.srvErrorInfoDialog.$emit('show')
        this.lastStaffMounted()
      }
      else {
        if (this.mSrvErrStatus === true) {
          // サーバエラーダイアログ表示中
          this.mSrvErrStatus = false
          this.$refs.srvErrorInfoDialog.$emit('hide')
        }
      }
    },*/
    // -------------------------------------------------------------------------
    // グループ選択が変更された時の処理
    //   子要素(GroupList.vue)からEvent通知される
    onSelectedGroupChanged: function (sectionId, groupId) {
      this.$log.debug('group changed ' + sectionId + ' : ' + groupId)
      this.$emit('showLoading')
      this.mCurrentSectionId = sectionId
      this.mCurrentGroupId = groupId

      // 行動予定情報を取得
      this.getWhereaboutsListAsyncWrap(sectionId, groupId)
      //this.getTeleworkingUserListAsync()
    },
    // -------------------------------------------------------------------------
    whSelectedOnMenu: function () {
      this.$store.dispatch('aChangeWASelectedOnMenu', false)
      this.onWhereaboutsInfoSelected(this.$store.getters.loginUserId)
    },
    // -------------------------------------------------------------------------
    // Listで行動予定情報が選択された時の処理
    //   子要素(WhereaboutsInfo.vue)からEvent通知される
    onWhereaboutsInfoSelected: async function (memberId) {
      this.$log.debug('member selected ' + memberId)
      await this.$store.dispatch(
        'aSelectUser',
        { companyId: this.$store.getters.loginUserCompanyId, memberId: memberId })
      this.$refs.selectedWhereaboutsInfoDialog.$emit('show')
    },
    // -------------------------------------------------------------------------
    // サーバに行先情報が送信された時の処理
    //   子要素(SelectedWhereaboutsDialog.vue)からEvent通知される
    onUpdateWhereaboutsInfo: function () {
      // 送信後に設定を反映させたいため、最新データを取得する
      this.getWhereaboutsListAsyncWrap(this.mCurrentSectionId, this.mCurrentGroupId)
      //this.getTeleworkingUserListAsync()
    },
    // -------------------------------------------------------------------------
    onRefresh: function () {
      // 行動予定情報を取得
      //this.$log.debug('★[onRefresh] リロードID(' + this.mAutoReloadId + ')')
      this.getWhereaboutsListAsyncWrap(this.mCurrentSectionId, this.mCurrentGroupId)
      //this.getTeleworkingUserListAsync()
    },
    // -------------------------------------------------------------------------
    // リストを再設定する
    resetWhereaboutsList: function () {
      //if (this.$vuetify.breakpoint.mdAndUp) {
      if (this.$store.getters.isMobile) {
      }
      else {
        if (this.mScreenView) {
          switch (this.mScreenLayout) {
            case '0':
              this._makeCarouselListScreen()
              break
            case '1':
              this._makeCarouselListScreen2col()
              break
            case '2':
              this._makeCarouselListGrid()
              break
            default:
              break
          }
        }
        else {
          this._make2ColumnList()
        }
      }
    },
    // -------------------------------------------------------------------------
    displayScreenView: function () {
      switch (this.mScreenLayout) {
        case '0':
          // １列表示
          this.mCarouselsCycle1 = true
          this.mCarouselsCycle2 = false
          this.mCarouselsCycleGrid = false
          this._makeCarouselListScreen()
          break
        case '1':
          // ２列表示
          this.mCarouselsCycle1 = false
          this.mCarouselsCycle2 = true
          this.mCarouselsCycleGrid = false
          this._makeCarouselListScreen2col()
          break
        case '2':
          // グリッド表示
          this.mCarouselsCycle1 = false
          this.mCarouselsCycle2 = false
          this.mCarouselsCycleGrid = true
          this._makeCarouselListGrid()
          break
        default:
          break
      }
    },
    // -------------------------------------------------------------------------
    startAutoReload: function () {
      const timer_id = setInterval(() => {
        this.onRefresh()
      }, RELOAD_INTERVAL)
      this.mAutoReloadId = timer_id
      console.log('!!! start : ' + this.mAutoReloadId)
    },
    // -------------------------------------------------------------------------
    stopAutoReload: function () {
      if (this.mAutoReloadId !== '') {
        clearInterval(this.mAutoReloadId)
        this.mAutoReloadId = ''
      }
    },
    // -------------------------------------------------------------------------
    // 表示データリスト作成 (スクリーン表示ON / 1列)
    _makeCarouselListScreen: function () {
      //this.$log.debug('★[_makeCarouselListScreen]')
      const lines = this._calcScreenLineNum()
      if (lines === 0) {
        // @Todo エラー表示
        return
      }

      // ページ表示用オブジェクトをクリア
      this.mScreenDispList1col = []

      // ページ切り替え数を算出
      this.mCarouselPages = Math.ceil((this.mWhereaboutsListMonitor.length / lines))
      this.$log.info('pages : ' + this.mCarouselPages)
      if (this.mCarouselPages === 0) {
        this.mLastStaffId = ''
        this.lastStaffMounted()
        return
      }

      // ページ表示用のオブジェクトを生成
      for (let i = 0; i < this.mCarouselPages; ++i) {
        let w_list = []
        for (let k = 0; k < lines; ++k) {
          if (((i * lines) + k) >= this.mWhereaboutsListMonitor.length) {
            break
          }
          w_list.push(this.mWhereaboutsListMonitor[(i * lines) + k])

          // １ページ目最後の社員の社員IDを取得
          if (i === 0 && (k === (lines - 1) || (k === (this.mWhereaboutsListMonitor.length - 1)))) {
            this.mLastStaffId = this.mWhereaboutsListMonitor[(i * lines) + k].staff_id
            //this.$log.debug('★ １ページ目最後の社員ID(' + this.mLastStaffId + ')')
          }
        }
        this.mScreenDispList1col.push(w_list)
      }
      //this.$log.debug('★表示データ→ ' + JSON.stringify(this.mScreenDispList1col))
    },
    // -------------------------------------------------------------------------
    // 表示データリスト作成 (スクリーン表示ON / 2列)
    _makeCarouselListScreen2col: function () {
      //this.$log.debug('★[_makeCarouselListScreen2col]')
      const lines = this._calcScreenLineNum()
      if (lines === 0) {
        // @Todo エラー表示
        return
      }

      // ページ表示用オブジェクトをクリア
      this.mScreenDispList2col = []

      // ページ切り替え数を算出
      let staffNum = lines * 2    // 1ページに表示する社員数(横２列表示)
      this.mCarouselPages = Math.ceil((this.mWhereaboutsListMonitor.length / staffNum))
      this.$log.info('pages : ' + this.mCarouselPages)
      if (this.mCarouselPages === 0) {
        this.mScreenDispList2col = [{ left: [], right: [] }]
        this.mLastStaffId = ''
        this.lastStaffMounted()
        return
      }

      // ページ表示用のオブジェクトを生成
      for (let i = 0; i < this.mCarouselPages; ++i) {
        let w_list = []
        let w_list1 = []
        let w_list2 = []
        for (let k = 0; k < staffNum; ++k) {
          if (((i * staffNum) + k) >= this.mWhereaboutsListMonitor.length) {
            break
          }
          w_list.push(this.mWhereaboutsListMonitor[(i * staffNum) + k])
          if ((((i * staffNum) + k) % 2) === 0) {
            w_list1.push(this.mWhereaboutsListMonitor[(i * staffNum) + k])
          }
          else {
            w_list2.push(this.mWhereaboutsListMonitor[(i * staffNum) + k])
          }

          // 1ページ目最後の社員の社員IDを取得
          if (i === 0 && (k === (staffNum - 1) || (k === (this.mWhereaboutsListMonitor.length - 1)))) {
            this.mLastStaffId = this.mWhereaboutsListMonitor[(i * staffNum) + k].staff_id
            //this.$log.debug('★ １ページ目最後の社員ID(' + this.mLastStaffId + ')')
          }
        }
        let tmpObj = { left: w_list1, right: w_list2 }
        this.mScreenDispList2col.push(tmpObj)
      }
      //this.$log.debug('★表示データ→ ' + JSON.stringify(this.mScreenDispList2col))
    },
    // -------------------------------------------------------------------------
    // 表示データリスト作成 (スクリーン表示ON / グリッド)
    _makeCarouselListGrid: function () {
      //this.$log.debug('★[_makeCarouselListGrid]')

      // ページ表示用オブジェクトをクリア
      this.mScreenGridList = []

      // １ユーザ表示エリアの高さを算出
      this.mGirdCardHeight = this._calcScreenGridCardHeight() + 'px'

      // ページ切り替え数を算出
      let staffNum = this.mGridColNum * this.mGridRowNum    // 1ページに表示する社員数(横５×縦６)
      this.mCarouselPages = Math.ceil((this.mWhereaboutsListMonitor.length / staffNum))
      //this.$log.info('pages : ' + this.mCarouselPages)
      if (this.mCarouselPages === 0) {
        this.mScreenGridList = []
        this.mLastStaffId = ''
        this.lastStaffMounted()
        return
      }

      // 最終ページで表示する列数を取得
      let lastPageColNum = 5    // ２行以上表示する場合は最大である５列まで使用されるので初期値5
      if ((this.mWhereaboutsListMonitor.length % staffNum) < 5) {
        lastPageColNum = this.mWhereaboutsListMonitor.length % staffNum
      }

      // ページ表示用のオブジェクトを生成
      let stuffPos = 0
      let colPos = 0
      let colList = []  // 同一列の社員データ配列
      let pageObj = []  // １ページ内の社員データ配列(２次元)
      for (let i = 0; i < this.mCarouselPages; ++i) {
        pageObj = []
        for (let k = 0; k < staffNum; ++k) {
          colList = []
          stuffPos = staffNum * i + k
          if (stuffPos >= this.mWhereaboutsListMonitor.length) {
            // 操作配列番号が社員数を超えたら終了
            //this.$log.debug('★    全社員終了')
            for (let m = 0; m < (5 - lastPageColNum); m++) {
              // 最終ページの列数が5未満の場合、列を追加
              colList = []
              colList.push({
                user_id: ''
              })
              pageObj.push(colList)
              //this.$log.debug('★ 列追加(' + JSON.stringify(pageObj) + ')')
            }
            break
          }
          //this.$log.debug('★  [' + i + '][' + k + '][stuffPos：' + stuffPos + '] ' + this.mWhereaboutsListMonitor[stuffPos].name)
          if (k <= (this.mGridColNum - 1)) {
            // １行目の場合、列配列をページ配列に追加する
            colList.push(this.mWhereaboutsListMonitor[stuffPos])
            pageObj.push(colList)
          }
          else {
            colPos = stuffPos % this.mGridColNum    // 配置する列番号を算出
            if (colPos >= 0 && colPos <= 4) {
              pageObj[colPos].push(this.mWhereaboutsListMonitor[stuffPos])
            }
          }
          // 1ページ目最後の社員の社員IDを取得
          if (i === 0 && (k === (staffNum - 1) || (k === (this.mWhereaboutsListMonitor.length - 1)))) {
            this.mLastStaffId = this.mWhereaboutsListMonitor[(i * staffNum) + k].staff_id
            //this.$log.debug('★ １ページ目最後の社員(' + this.mLastStaffId + ')' + this.mWhereaboutsListMonitor[(i * staffNum) + k].name)
          }
        }
        this.mScreenGridList.push(pageObj)
        //this.$log.debug('★    １ページ内ループ終了')
      }
      //this.$log.debug('★作成データ→' + JSON.stringify(this.mScreenGridList))
    },
    // -------------------------------------------------------------------------
    // スクリーン表示モード(１列or２列)時の１ページ当たりの表示行数算出
    _calcScreenLineNum: function () {
      // window.innerWidth * (0.06)はアバターサイズ(WhereaboutsInfo.vueにて設定)、
      // 10は上下padding分、5は微調整
      let lineHeight = window.innerWidth * (0.06) + 10 + 5
      if (this.isScreenView2Column) {
        // ２列表示の場合
        // (帰社日時欄の高さ＋行先/メモ欄の高さ＋微調整)
        lineHeight = (window.innerWidth * (0.017) * 2 + 20) + (window.innerWidth * (0.0175) + 10) + 3
      }
      // 60はNavbar高さ
      // window.innerWidth * 0.015 + 20 はグループ選択リストの高さ(フォントサイズ1.5vw + 上下margin)
      // 40はリスト表示エリアの上のmargin、60は下に余力を持たせるためのサイズ
      //const validHeight = window.innerHeight - (60 + (window.innerWidth * 0.015 + 20) + 40 + 60)
      const validHeight = this._calcContainerHeight()
      const lines = Math.trunc(Number(validHeight / lineHeight))    // 1ページの行数
      this.$log.info('innerHeight : ' + window.innerHeight + ' innerWidth : ' + window.innerWidth)
      this.$log.info('top margin : ' + (60 + window.innerWidth * 0.015 + 20) + ' validHeight : ' + validHeight + ' line height : ' + lineHeight)
      this.$log.info('Avatar size : ' + (window.innerWidth * (0.06)))
      this.$log.info('lines : ' + lines)
      //this.mDispAreaHeight = validHeight + 35
      this.mDispAreaHeight = validHeight
      return lines
    },
    // -------------------------------------------------------------------------
    // スクリーン表示モード(グリッド)時の１ユーザ表示エリアの高さを算出
    _calcScreenGridCardHeight: function () {
      this.mDispAreaHeight = this._calcContainerHeight()
      //this.$log.debug('★[_calcScreenGridCardHeight] コンテナの高さ(' + this.mDispAreaHeight + ')  １ユーザ領域の高さ(' + (this.mDispAreaHeight / 6) + ')')
      return ((this.mDispAreaHeight - 12) / 6)
    },
    // -------------------------------------------------------------------------
    // 行先一覧表示エリアの高さを算出
    _calcContainerHeight: function () {
      // window.innerWidth * 0.015 + 20 はグループ選択リストの高さ(フォントサイズ1.5vw + 上下margin)
      // 40はリスト表示エリアの上のmargin、60は下に余力を持たせるためのサイズ
      return (window.innerHeight - (60 + (window.innerWidth * 0.015 + 20) + 20 + 30))
    },
    // -------------------------------------------------------------------------
    // 表示データリスト作成 (スクリーン表示OFF)
    _make2ColumnList: function () {
      //this.$log.debug('★[_make2ColumnList]')
      // clear column list
      this.mDisplayListColumn1 = []
      this.mDisplayListColumn2 = []

      if (this.mWhereaboutsListMonitor.length === 0) {
        this.mLastStaffId = ''
        this.lastStaffMounted()
        return
      }

      // make new column list
      for (let i = 0; i < this.mWhereaboutsListMonitor.length; i++) {
        if ((i % 2) === 0) {
          this.mDisplayListColumn1.push(this.mWhereaboutsListMonitor[i])
        }
        else {
          this.mDisplayListColumn2.push(this.mWhereaboutsListMonitor[i])
        }
        if (i === (this.mWhereaboutsListMonitor.length - 1)) {
          // 最後の社員の社員IDを取得
          this.mLastStaffId = this.mWhereaboutsListMonitor[this.mWhereaboutsListMonitor.length - 1].staff_id
          //this.$log.debug('★ 最後の社員ID(' + this.mLastStaffId + ')')
        }
      }
      this.lastStaffMounted()   // 検索フォーム入力有りの場合、最後の社員IDが↑の処理で取得したものと異なるため、ここでローディングを停止する
      //this.$log.debug('★表示データ (１)→ ' + JSON.stringify(this.mDisplayListColumn1))
      //this.$log.debug('★表示データ (２)→ ' + JSON.stringify(this.mDisplayListColumn2))
    },
    // -------------------------------------------------------------------------
    onClickReload: function () {
      this.$emit('showLoading')
      this.onRefresh()
      // Avatar画像の更新、ユーザの追加、削除があるため、リロードボタンの押下時は、
      // ユーザ情報を更新する
      this.getUserList()
    },
    // -------------------------------------------------------------------------
    // ユーザ情報一覧取得(名前、拠点/所属、表示順、画像など)
    getUserList: function () {
      //const result = await this.$store.dispatch(
      const result = this.$store.dispatch(
        'aGetUserList',
        this.$store.getters.loginUserCompanyId,
      )

      if (result.error) {
        this.mSrvErrStatus = true
        this.$refs.srvErrorInfoDialog.$emit('show')
        this.lastStaffMounted()
      }
      else {
        if (this.mSrvErrStatus === true) {
          // サーバエラーダイアログ表示中
          this.mSrvErrStatus = false
          this.$refs.srvErrorInfoDialog.$emit('hide')
        }
      }
    },
    // -------------------------------------------------------------------------
    onScroll: function () {
      this.mOffsetTop = window.pageYOffset || document.documentElement.scrollTop
    },
    // -------------------------------------------------------------------------
    onSwipe: function (direction) {
      switch (direction) {
        case 'right':
          this.onSwipeRight()
          break
        case 'down':
          this.onSwipeDown()
          break
        default:
          break
      }
    },
    // -------------------------------------------------------------------------
    onSwipeRight: function () {
      this.$router.push({
        name: ROUTE_NAME.ROUTE_WHEREABOUTS_INFO,
        params: { id: this.$store.getters.loginUserId }
      })
    },
    // -------------------------------------------------------------------------
    onSwipeDown: function () {
      if (this.mOffsetTop === 0) {
        this.getWhereaboutsListAsyncWrap(this.mCurrentSectionId, this.mCurrentGroupId)
        //this.getTeleworkingUserListAsync()
      }
    },
    // -------------------------------------------------------------------------
    // ログイントークンを再発行
    reissueLoginTokenAsync: async function () {
      let result = await this.$store.dispatch('aReissueLoginToken')
      if (result.error || result.body.error) {
        // token認証に失敗した場合は、ID/PWログイン画面を表示する
        this.mErrorMsg = '認証に失敗しました。再ログインして下さい。'
      }
      return result
    },
    // -------------------------------------------------------------------------
    // トークン再発行エラーに表示するダイアログのコールバック関数
    dispLoginPage: function () {
      this.$router.push(ROUTE_PATH.ROUTE_LOGIN)
    },
    // -------------------------------------------------------------------------
    // 強制リロード
    reloadPage: function () {
      location.reload(true)
    },
    // -------------------------------------------------------------------------
    // データ配列クリア
    clearWhereaboutsList: function () {
      this.mWhereaboutsListMobile = []    // Mobile
      this.mDisplayListColumn1 = []       // screen:off left-side
      this.mDisplayListColumn2 = []       // screen:off right-side
      this.mScreenDispList1col = []       // screen:on 1column
      this.mScreenDispList2col = []       // screen:on 2column
      this.mScreenGridList = []
    }
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-wal-wrap {
  height: 0vh;  /* carouselの高さ設定はうまくできない. 正式対応は、Vuetify 1.2.xの予定 */
}

.hm-wal-clm {
  padding: 0 3px;
}

/* グループ一覧選択
.hm-wal-group {
  width: 20%;
  margin-top: 20px;
  margin-left: auto;
  margin-right: 10px;
  padding: 5px;
  text-align: center;
  color: white;
}
@media screen and (max-width: 600px) {
.hm-wal-group {
  width: 40%;
  margin-top: 5px;
  margin-left: auto;
}
}

.hm-wal-groupselect {
  margin-top: 10px;
  height: 40px;
} */
@media screen and (max-width: 960px) {
  /* 幅～960px */
  .hm-wal-group-area {
    margin-top: 12px;   /*ブラウザ幅960pxあたりでヘッダ部分の高さが48pxで自動調整され、グループ選択リストが上に詰まってしまう*/
  }
}

.hm-wal-container {
  margin-top: 20px;
}
@media screen and (max-width: 600px) {
.hm-wal-container {
  margin-top: 5px;
}
}

.hm-wal-search {
  padding-left: 10px;
  padding-right: 30px;
}

.hm-wal-grid {
  margin: 0 10px;
  height: 100%;
  border: none;
}
.hm-wal-grid-card {
  width: 20%;
}

</style>



// WEBPACK FOOTER //
// src/components/WhereaboutsList.vue